import { render, staticRenderFns } from "./data23.vue?vue&type=template&id=94f9524c&scoped=true&"
import script from "./data23.vue?vue&type=script&lang=js&"
export * from "./data23.vue?vue&type=script&lang=js&"
import style1 from "./data23.vue?vue&type=style&index=1&id=94f9524c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f9524c",
  null
  
)

export default component.exports